export default {
    common: {
        title: '课堂结果',
    },
    studentResult: {
        subtitle: '让我们看看学到了什么吧！',
        totalActivities: '总共完成了 { count } 个活动！',
    },
    teacherResult: {
        sessionInfo: '课堂信息',
        sessionInfoItem: {
            title: '课堂基本信息',
            date: '日期',
            duration: '进行时间',
            studentCount: '参与人数',
            curriculum: '小单元',
        },
        noModules: '没有已进行的活动。',
        showMvp: 'MVP 发表',
    },
};
